import { render } from "./TilePaginatedDashboard.vue?vue&type=template&id=592a7af4&scoped=true&ts=true"
import script from "./TilePaginatedDashboard.vue?vue&type=script&lang=ts"
export * from "./TilePaginatedDashboard.vue?vue&type=script&lang=ts"

import "./TilePaginatedDashboard.vue?vue&type=style&index=0&id=592a7af4&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592a7af4"]])

export default __exports__